<template>
    <div class="col-xs-12 col-sm-4 col-md-3 agx-list-oneInRow"
        v-bind:style="{ 'background': 'url(' + item.thumbPath + ')', 'height': '100px', 'background-size': '100% auto' }">
        <div>
            <div>
                <div class="agx-post-tag" style="z-index:1;padding:4px;width:100%;">
                    <div style="text-align:right;position:absolute;right:0px;">
                        <div>{{ item.zoneEditDatetime }}</div>
                        <div>{{ item.title }}</div>
                        <!-- <div v-if="item.category !== null">
                            <span class="label label-primary" style="z-index:1;">{{ item.parentCategory.name }} </span>
                            <span class="label label-info" style="z-index:1;"> {{ item.category.name }} </span>
                        </div> -->
                    </div>
                    <div style="height: 80px;" @click="onselect(item)">
                        <!-- <img v-if="item.thumbPath !== null"
                            style="max-height:80px;display:inline-block;border-radius:4px;" class="img-responsive"
                            :src="item.thumbPath" :title="item.title"> -->
                            <!-- <img
                            style="max-height:80px;display:inline-block;border-radius:4px;" class="img-responsive"
                            src="locationSvg"> -->
                            <div class="pbcss-location-logo" style="display: inline-block;width: 80px;height: 80px;">
                            </div>
                    </div>
                    <!-- <div
                        style="height: 140px; overflow: hidden; background: rgba(251,249,249,0.1); border-top: 1px solid white;">

                        <div @click="onselect(item)">
                            <div style="padding:2px;font-weight:bold;cursor:pointer;">{{ item.title }}</div>
                        </div>
                        <div style="white-space:pre-line;">{{ item.textMsg }}</div>
                    </div> -->
                </div>
                <!-- <div class="agx-post-intros" style="width: 100%;text-align: right">
                    <div class="btn" style="float: left;" >
                        <span v-if="item.stateCode === 0" class="glyphicon glyphicon-ok" style="color: green;">{{ lang.postEditor.public }}</span>
                        <span v-else class="glyphicon glyphicon-unchecked" style="color: red;"></span>
                    </div>
                    <span class="btn btn-default" v-if="item.stateCode === 0" @click="onShare">{{lang.common.share}}</span>
                    <div class="btn btn-default" @click="onselect(item)" style="margin-left: 16px;">
                            {{ lang.common.edit }}
                    </div>
                </div> -->
                <div class="agx-trans-layer"></div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    computed: {
        lang: function () {
            return this.$store.getters.lang;
        }
    },
    props: ["item"],
    data: function () {
        return {
            
        }
    },
    methods: {
        onselect: function (ret) {
            this.$emit('onselect', ret);
        },
        onShare:function(){
            let item = this.item;
            this.mxnPromptShare({url:item.itemPath});
        }
    },
    mounted: function () {

    }
}
</script>